/* eslint-disable object-curly-newline */
import httpUtils from '@/utils/http-utils';
import i18n from '@/plugins/vue-i18n';

const baseRequesterOptions = {
  baseUrl: `${window.processEnv.VUE_APP_CRM_API_BASE_URL_V2}/shopping-carts`,
  requesterType: 'CMS_WEB_SERVICE',
};
const shoppingCartApiReqNotification = httpUtils.createRequester(baseRequesterOptions);
const shoppingCartApiReqErrorHandling = httpUtils.createRequester(baseRequesterOptions, 'errorHandling');

const getRequester = (errorManagementType) => {
  if (errorManagementType === 'errorHandling') {
    return shoppingCartApiReqErrorHandling;
  }

  return shoppingCartApiReqNotification;
};

//User Cart Calculation
const baseCartCalculationRequesterOptions = {
  baseUrl: `${window.processEnv.VUE_APP_CRM_API_BASE_URL_V2}/sales-orders/calculate`,
  requesterType: 'CRM_WEB_SERVICE',
};
const resetCartCalculationApiReqNotification = httpUtils.createRequester(baseCartCalculationRequesterOptions);
const resetCartCalculationApiReqErrorHandling = httpUtils.createRequester(baseCartCalculationRequesterOptions, 'errorHandling');

const userCartCalculationRequester = (errorManagementType) => {
  if (errorManagementType === 'errorHandling') {
    return resetCartCalculationApiReqErrorHandling;
  }

  return resetCartCalculationApiReqNotification;
};

class ShoppingCartApi {
  createShoppingCart(shoppingCart, errorManagementType) {
    return getRequester(errorManagementType)
      .post('/', shoppingCart, {
        headers: {
          'accept-language': i18n.locale,
        },
      }).then(res => res && res.data);
  }

  fetchShoppingCart(id, idType, errorManagementType) {
    return getRequester(errorManagementType)
      .get(`/${id}`, {
        headers: {
          'accept-language': i18n.locale,
        },
        // params: {
        //   idType,
        // },
      }).then(res => res && res.data);
  }

  updateShoppingCart(id, shoppingCart, errorManagementType) {
    return getRequester(errorManagementType)
      .put(`/${id}`, shoppingCart, {
        headers: {
          'accept-language': i18n.locale,
        },
      }).then(res => res && res.data);
  }

  addProductToShoppingCart(id, product, errorManagementType) {

    return getRequester(errorManagementType)
      .put(`/${id}/add-product`, { product }, {
        headers: {
          'accept-language': i18n.locale,
        },
      }).then(res => res && res.data);
  }

  getCartCalculation(cartData, errorManagementType) {
    return userCartCalculationRequester(errorManagementType)
      .post(`/`, cartData)
      .then(res => res && res.data);
  }

}

export default new ShoppingCartApi();
